import { initializeApp } from 'firebase/app'
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from 'firebase/storage'
import { AnimatePresence } from 'framer-motion'
import { Warning } from 'phosphor-react'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CloseIcon } from 'src/assets/icons/closeIcon'
import { DashboardIcon } from 'src/assets/icons/dashboardIcon'
import { ExtractIcon } from 'src/assets/icons/extractIcon'
import { ListIcon } from 'src/assets/icons/listIcon'
import { PaymentIcon } from 'src/assets/icons/paymentIcon'
import { PixIcon } from 'src/assets/icons/pixIcon'
import { WalletIcon } from 'src/assets/icons/walletIcon'
import { useAuth } from 'src/hooks/auth'
import { api } from 'src/services/api'
import { firebaseConfig } from 'src/services/firebase'
import { getInitialOfName } from 'src/utils/getIninitialName'
import { isAxiosError } from 'src/utils/isAxiosError'
import logo from '../../assets/product-config/logo-black.png'
import { showAlertError } from '../alertError'
import { showAlertSuccess } from '../alertSuccess'
import { BellMessage } from '../bellMessage'
import {
  BellIcon,
  BellNotifications,
  BellWrapper,
  BoxNotifications,
  BoxWrapper,
  ButtonBell,
} from '../header/styles'
import Search from './components/Search'
import { Settings } from './components/Settings'
import { Box, HeaderContainer, Logo, NavIcons, UserIcons } from './headerStyles'

export const DashboardHeader = () => {
  const { user } = useAuth()
  const audioMP3 = require('../../assets/cash-in.mp3')
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const token = localStorage.getItem('@stricv2:token')

  const audioRef = useRef<HTMLAudioElement>(null)
  const [notifications, setNotifications] = useState<any[]>([])
  const [quantity, setQuantity] = useState(0)
  const wrapperRef = useRef<HTMLDivElement | null>(null)
  const [preview, setPreview] = useState<string | null>(null)
  const [image, setImage] = useState<string>('') // Estado para a imagem principal.
  const [profileSecond, setProfileSecond] = useState<string>('') // Estado para a segunda imagem.
  const [percent, setPercent] = useState(0)
  const [imageUri, setImageUri] = useState<string>('')

  const handleClickOutside = (event: MouseEvent) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target as Node)
    ) {
      setBoxMessageIsActive(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const mobileNavigation = (path: string) => {
    navigate(path)
    setIsOpen(false)
  }

  const fetchNotifications = async () => {
    try {
      const url = '/notifications'
      const { data } = await api.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      console.log('notifications', data.notifications)
      setQuantity(data.quantity)
      if (data.quantity > 0) {
        try {
          audioRef.current!.play()
        } catch (error) {
          console.log(error)
        }
      }
      setNotifications(data.notifications)
    } catch (error) {}
  }

  useEffect(() => {
    fetchNotifications()
  }, [])

  const [BellBoxMessageIsActive, setBoxMessageIsActive] = useState(false)

  const HandleBoxMessageToggle = async () => {
    if (quantity > 0) {
      try {
        const url = '/notifications/read'
        const { data } = await api.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        })
        console.log('notifications', data.notifications)
        setQuantity(data.quantity)
        setNotifications(data.notifications)
      } catch (error) {}
    }
    setBoxMessageIsActive((state) => !state)
  }

  const getProfilePicure = async () => {
    try {
      const response = await api.get(`/media/get-profile-picture/${user.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setImage(response.data.current) // Define a imagem principal.
      setProfileSecond(response.data.second) // Define a segunda imagem.
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        const errorMessage = (error.response.data as { code: string }).code
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    }
  }

  useEffect(() => {
    if (user) {
      getProfilePicure() // Busca as imagens do perfil ao carregar o componente ou quando o usuário muda.
    }
  }, [user])

  ///////////////

  const handleUpload = async (imageUri: any) => {
    try {
      initializeApp(firebaseConfig)

      const storage = getStorage()
      const response = await fetch(imageUri)
      const blob = await response.blob()
      const imageName = imageUri.substring(imageUri.lastIndexOf('/') + 1)
      const storageRef = ref(storage, `/files/${imageName}`)

      const uploadTask = uploadBytesResumable(storageRef, blob)

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          )
          setPercent(percent)
        },
        (error) => {
          console.error('Error uploading file:', error)
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            console.log('File available at', downloadURL)
            setImage(downloadURL)
            updateProfilePicure(downloadURL)
            setPercent(0)
          })
        }
      )
    } catch (error) {
      console.log(error)
    } finally {
      setPercent(0)
    }
  }
  ////////////////////
  const updateProfilePicure = async (url: any) => {
    try {
      await api.put(
        `/media/update-profile-picture/${user.id}`,
        { url: url },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      getProfilePicure()
      showAlertSuccess('Imagem atualizada com sucesso!')
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        const errorMessage = (error.response.data as { code: string }).code
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    }
  }

  const handleSelectImage = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files // `files` é do tipo `FileList | null`
    if (files && files.length > 0) {
      const file = files[0] // Pega o primeiro arquivo
      const imageUri = URL.createObjectURL(file) // Cria um URI temporário para o arquivo
      await handleUpload(imageUri)
    } else {
      console.error('Nenhum arquivo selecionado.')
    }
  }

  return (
    <HeaderContainer>
      <Logo>
        <button
          className="max-h-[60px]"
          type="button"
          onClick={() => navigate('/')}
        >
          <img
            src={logo}
            className="object-contain max-h-[60px]"
            alt="Symbank Logo"
          />
        </button>
      </Logo>
      <NavIcons>
        <button
          type="button"
          onClick={() => navigate('/')}
          className={`h-[48px] w-[48px] 1xl:h-[58px] 1xl:w-[58px] 3xl:w-[85px] 3xl:h-[85px] 6xl:w-[110px] 6xl:h-[110px] flex justify-center rounded-full items-center ${
            location.pathname === '/' ? 'bg-[#aaa] border-2 border-black' : ''
          }`}
        >
          <DashboardIcon className="w-[30px] h-[30px] 1xl:h-[40px] 1xl:w-[40px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px] " />
        </button>
        <button
          type="button"
          onClick={() => navigate('/infractions')}
          className={`h-[48px] w-[48px] 1xl:h-[58px] 1xl:w-[58px] 3xl:w-[85px] 3xl:h-[85px] 6xl:w-[110px] 6xl:h-[110px] flex justify-center rounded-full items-center ${
            location.pathname === '/infractions'
              ? 'bg-[#aaa] border-2 border-black'
              : ''
          }`}
        >
          <Warning className="w-[30px] h-[30px] 1xl:h-[40px] 1xl:w-[40px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px] " />
        </button>
        <button
          type="button"
          onClick={() => navigate('/extract')}
          className={`h-[48px] w-[48px] 1xl:h-[58px] 1xl:w-[58px] 3xl:w-[85px] 3xl:h-[85px] 6xl:w-[110px] 6xl:h-[110px] flex justify-center rounded-full items-center ${
            location.pathname.split('/')[1] === 'extract'
              ? 'bg-[#aaa] border-2 border-black'
              : ''
          }`}
        >
          <ExtractIcon className="w-[30px] h-[30px] 1xl:h-[40px] 1xl:w-[40px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px]" />
        </button>
        <button
          type="button"
          onClick={() => navigate('/pix')}
          className={`h-[48px] w-[48px] 1xl:h-[58px] 1xl:w-[58px] 3xl:w-[85px] 3xl:h-[85px] 6xl:w-[110px] 6xl:h-[110px] flex justify-center rounded-full items-center ${
            location.pathname.split('/')[1] === 'pix'
              ? 'bg-[#aaa] border-2 border-black'
              : ''
          }`}
        >
          <PixIcon className="w-[30px] h-[30px] 1xl:h-[40px] 1xl:w-[40px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px] " />
        </button>
        <button
          type="button"
          onClick={() => navigate('/wallet/balancete')}
          className={`h-[48px] w-[48px] 1xl:h-[58px] 1xl:w-[58px] 3xl:w-[85px] 3xl:h-[85px] 6xl:w-[110px] 6xl:h-[110px]  flex justify-center rounded-full items-center ${
            location.pathname.split('/')[1] === 'wallet'
              ? 'bg-[#aaa] border-2 border-black'
              : ''
          }`}
        >
          <WalletIcon className="w-[30px] h-[30px] 1xl:h-[40px] 1xl:w-[40px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px]" />
        </button>
        <button
          type="button"
          onClick={() => navigate('/maquininha')}
          className={`h-[48px] w-[48px] 1xl:h-[58px] 1xl:w-[58px] 3xl:w-[85px] 3xl:h-[85px] 6xl:w-[110px] 6xl:h-[110px]  flex justify-center rounded-full items-center ${
            location.pathname.split('/')[1] === 'maquininha'
              ? 'bg-[#aaa] border-2 border-black'
              : ''
          }`}
        >
          <PaymentIcon className="w-[30px] h-[30px] 1xl:h-[40px] 1xl:w-[40px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px]" />
        </button>
      </NavIcons>
      <Search />
      <UserIcons>
        <Settings ref={wrapperRef} />
        <BellWrapper ref={wrapperRef}>
          <ButtonBell onClick={HandleBoxMessageToggle}>
            <BellIcon />
          </ButtonBell>
          <BellNotifications>
            <p>{quantity}</p>
            <audio ref={audioRef} src={audioMP3} />
          </BellNotifications>
          <AnimatePresence>
            {BellBoxMessageIsActive && (
              <BoxWrapper
                initial={{ opacity: 0, y: '-10%' }}
                animate={{ opacity: 1, y: '0%' }}
                exit={{ opacity: 0, y: '-10%' }}
                transition={{ duration: 0.2 }}
              >
                <Box>
                  <BoxNotifications>
                    {notifications.length === 0 ? (
                      <BellMessage
                        notification={{
                          title: 'Nenhuma mensagem',
                          message: 'Nenhuma mensagem pendente',
                        }}
                      />
                    ) : (
                      notifications.map((notification, index) => (
                        <BellMessage key={index} notification={notification} />
                      ))
                    )}
                  </BoxNotifications>
                </Box>
              </BoxWrapper>
            )}
          </AnimatePresence>
        </BellWrapper>

        <label
          htmlFor="avatar"
          className="flex justify-center items-center cursor-pointer rounded-full overflow-hidden"
          style={{
            width: '60px', // defina o tamanho padrão
            height: '60px', // igual à largura para manter o círculo
          }}
        >
          {image ? (
            <img
              src={image}
              alt="User Icon"
              className="border border-[#191919] rounded-full"
              style={{
                width: '100%', // garante que a imagem preencha o contêiner
                height: '100%',
                objectFit: 'cover', // mantém proporções corretas
              }}
            />
          ) : (
            <div
              className="bg-[#191919] font-bold text-white flex justify-center items-center"
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '50%', // círculo perfeito
                fontSize: '20px',
              }}
            >
              <p>{getInitialOfName(user.name)}</p>
            </div>
          )}
          <input
            id="avatar"
            type="file"
            onChange={handleSelectImage}
            onClick={() => updateProfilePicure('')}
            accept=".jpg, .jpeg, .png"
            className="hidden"
          />
        </label>
      </UserIcons>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex md:hidden absolute top-7 right-5"
      >
        {isOpen ? (
          <CloseIcon className="w-[25] h-[25]" />
        ) : (
          <ListIcon className="w-[25] h-[25]" />
        )}
      </button>
      {isOpen && (
        <div className="w-full flex flex-col items-center gap-2 bg-[#fff]">
          <button
            type="button"
            onClick={() => mobileNavigation('/')}
            className="h-12 w-12 flex justify-center rounded-full items-center"
          >
            <DashboardIcon className="w-[30] h-[30]" />
          </button>
          <button
            type="button"
            onClick={() => mobileNavigation('/extract')}
            className="h-12 w-12 flex justify-center rounded-full items-center"
          >
            <ExtractIcon className="w-[26] h-[25]" />
          </button>
          <button
            type="button"
            onClick={() => mobileNavigation('/pix')}
            className="h-12 w-12 flex justify-center rounded-full items-center"
          >
            <PixIcon className="w-[26] h-[25]" />
          </button>
          <button
            type="button"
            onClick={() => mobileNavigation('/wallet')}
            className="h-12 w-12 flex justify-center rounded-full items-center"
          >
            <WalletIcon className="w-[30] h-[30]" />
          </button>
          <button
            type="button"
            onClick={() => mobileNavigation('/my-terminals')}
            className="h-12 w-12 flex justify-center rounded-full items-center"
          >
            <PaymentIcon className="w-[23] h-[26]" />
          </button>
        </div>
      )}
    </HeaderContainer>
  )
}
